var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenTerminal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.80455 2.32407C0.363211 1.89269 0.363211 1.18267 0.80455 0.751291C1.23187 0.333619 1.91451 0.333619 2.34183 0.751291L9.42119 7.67086C9.86253 8.10223 9.86253 8.81226 9.42119 9.24364C8.99387 9.66131 8.31123 9.66131 7.88391 9.24364L0.80455 2.32407Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34183 16.2487C1.91451 16.6664 1.23187 16.6664 0.80455 16.2487C0.363212 15.8173 0.363211 15.1073 0.80455 14.6759L7.88391 7.75636C8.31122 7.33869 8.99387 7.33869 9.42119 7.75636C9.86253 8.18774 9.86253 8.89777 9.42119 9.32914L2.34183 16.2487Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7716,
    y: 14.4219,
    width: 12.2284,
    height: 2.13745,
    rx: 1.06872,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTerminal);
export default __webpack_public_path__ + "static/media/open-terminal.a1080c0d3962e363c187567569031b8a.svg";
export { ForwardRef as ReactComponent };